<div id="freshpass-benefits-container margin-xlg-64">
    <div class="fp-perks-title mb12 m0">
        <h2 class="fs24-text fw-n mb-8">{{properties.confirmation.YOUR_FRESH_PASS_BENEFITS}}</h2>
    </div>
    <div class="container p0 clear-fix mb24 container-gallery">
        <div class="container p0">
            <div class="freshpass-tiles__dynamic">
                <div *ngFor="let tile of tileArray"
                     aria-label="Benefit Tile"
                     class="freshpass-tile-item-proxy freshpass-tile-item section confirmation-tile-alignment" role="region" tabindex="0">
                    <div class="row">
                        <div class="freshpass-tile-item-image col-md-12 remove-rl-padding">
                            <img [alt]="tile.tileImageAltText" [src]="tile.tileImage" role="img">
                        </div>
                        <div class="freshpass-tile-item-text col-md-12 remove-rl-padding">
                            <div [innerHTML]="tile.rteTitle"
                                 class="freshpass-tile-item-text-align confirmation-tile-text-alignment unlimited-free-delivery">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
